export const DailyBonusIcon = () => {
    return (
        <svg width="33" height="24" viewBox="0 0 33 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_32188_10510)">
                <path
                    d="M28 0H5C5 0 0.5 3.02 0.5 9.68L2.51 24H30.48L32.49 9.68C32.5 3.02 28 0 28 0ZM30.46 9H27.72C27.6 6 26.65 3.56 25.64 2H27.31C28.22 2.81 30.25 5.08 30.47 9H30.46ZM12.44 9.95C12.44 9.62 12.49 9.3 12.57 9H6.37C6.51 5.83 7.65 3.33 8.67 2H24.42C24.46 2.06 24.5 2.11 24.54 2.17C24.62 2.28 24.69 2.38 24.77 2.5C24.86 2.63 24.94 2.78 25.03 2.93C25.11 3.06 25.18 3.19 25.26 3.33C25.35 3.49 25.43 3.68 25.51 3.85C25.58 4 25.66 4.15 25.72 4.31C25.8 4.5 25.87 4.72 25.95 4.93C26.01 5.1 26.08 5.26 26.13 5.44C26.2 5.67 26.26 5.92 26.32 6.17C26.36 6.35 26.42 6.52 26.46 6.7C26.52 6.98 26.56 7.29 26.6 7.59C26.62 7.75 26.66 7.91 26.68 8.08C26.71 8.38 26.72 8.69 26.73 9H20.59C20.67 9.31 20.72 9.62 20.72 9.95C20.72 10.31 20.67 10.66 20.58 11H26.56L25.02 22H8.06L6.52 11H12.58C12.49 10.66 12.44 10.31 12.44 9.95ZM5.7 2H7.45C6.45 3.55 5.5 5.98 5.37 9H2.54C2.76 5.08 4.79 2.81 5.7 2ZM2.71 11H5.52L7.06 22H4.26L2.71 11ZM26.02 22L27.55 11H30.29L28.74 22H26.02Z"
                    fill="#231F20"
                />
                <path
                    d="M19.0902 15.42L17.9902 12.13C18.6502 11.66 19.0902 10.89 19.0902 10.02C19.0902 8.58999 17.9302 7.42999 16.5002 7.42999C15.0702 7.42999 13.9102 8.58999 13.9102 10.02C13.9102 10.89 14.3502 11.66 15.0102 12.13L13.9102 15.42H19.0902Z"
                    fill="#231F20"
                />
            </g>
            <defs>
                <clipPath id="clip0_32188_10510">
                    <rect width="32" height="24" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    )
}
